import { render, staticRenderFns } from "./FontPicker.vue?vue&type=template&id=61e382c8&scoped=true"
import script from "./FontPicker.vue?vue&type=script&lang=js"
export * from "./FontPicker.vue?vue&type=script&lang=js"
import style0 from "./FontPicker.vue?vue&type=style&index=0&id=61e382c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e382c8",
  null
  
)

export default component.exports